export default __webpack_public_path__ + "static/media/AVSFLIX LOGO.2950ed48.png";